import { defineMessages } from "react-intl";

import { Role } from "@mapmycustomers/shared";

import ChecklistDescriptor from "@app/component/flows/types/ChecklistDescriptor";

import { addingResourcesTourConfiguration } from "./addingResourcesTour";
import { foldersTourConfiguration } from "./foldersTour";
import { operationsTourConfiguration } from "./resourceOperationsTour";
import { sharingPermissionsTourConfiguration } from "./sharingPermissionsTour";

const messages = defineMessages({
  addingResources: {
    id: "guides.resources.checklist.addingResources",
    defaultMessage: "Uploading (Pinning) a New Resource",
  },
  description: {
    id: "guides.resources.checklist.description",
    defaultMessage:
      "This guide teaches new users how to use Pinned Resources within Map My Customers. Pinned Resources are a way to store and quickly access files, links, and reference documents directly in your MMC workspace — helping you find what you need without digging through folders or chat threads.",
  },
  folders: {
    id: "guides.resources.checklist.folders",
    defaultMessage: "Creating and Using Folders",
  },
  operations: {
    id: "guides.resources.checklist.operations",
    defaultMessage: "Resource Operations",
  },
  sharingPermissions: {
    id: "guides.resources.checklist.sharingPermissions",
    defaultMessage: "Sharing Permissions",
  },
  title: {
    id: "guides.resources.checklist",
    defaultMessage: "Welcome to Pinned Resources",
  },
});

export const resourcesChecklistConfiguration: ChecklistDescriptor = {
  id: "mmc-resources",
  steps: [
    {
      id: "adding-resources",
      title: messages.addingResources,
      tour: addingResourcesTourConfiguration,
    },
    {
      id: "folders",
      path: "/resources",
      title: messages.folders,
      tour: foldersTourConfiguration,
    },
    {
      id: "operations",
      path: "/resources",
      title: messages.operations,
      tour: operationsTourConfiguration,
    },
    {
      id: "sharingPermissions",
      eligibleRoles: [Role.OWNER],
      title: messages.sharingPermissions,
      tour: sharingPermissionsTourConfiguration,
    },
  ],
  subTitle: messages.description,
  title: messages.title,
};
